import { useDispatch } from "react-redux";
import { multiUpdateGlobalState } from "src/features/globalSlice";
import SvgIcon from "../../shared/minicomponents/SvgIcon";
import s from "./MobileNavIcon.module.scss";

const MobileNavIcon = () => {
  const dispatch = useDispatch();

  return (
    <button
      type="button"
      className={s.mobileNav}
      onClick={() => openMobileNav(dispatch)}
      aria-label="Toggle navigation menu"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24"
        height="24"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {/* Circular Border */}
        <circle cx="12" cy="12" r="10" fill="none" />

        {/* User Head */}
        <circle cx="12" cy="8" r="3" />

        {/* Shoulders */}
        <path d="M6 18c0-3 3-5 6-5s6 2 6 5" />
      </svg>
    </button>
  );
};
export default MobileNavIcon;

function openMobileNav(dispatch) {
  const payload = {
    isMobileMenuActive: true,
    isOverlayActive: true,
  };
  dispatch(multiUpdateGlobalState(payload));
}
